const carouselItems = [
  {
    id: 1,
    title: 'Jump系少年漫画的黄金时代',
    desc: '从《龙珠》到《海贼王》，再到《咒术回战》，少年Jump如何在半个世纪里持续缔造日漫传奇？本期专题带你回顾那些点燃青春的经典瞬间，并展望新一代Jump系作品的可能性。',
    tag: '深度专题',
    color: 'from-primary-500/90 to-primary-700/90',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Japanese%20shonen%20manga%20collage%20style%20illustration%20with%20dynamic%20action%20composition%2C%20warm%20coral%20and%20amber%20color%20scheme%2C%20heroic%20atmosphere%2C%20energetic%20vibe%2C%20editorial%20quality%2C%20artistic%20rendering%2C%20no%20text&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '从漫画到动画：年度最佳改编作品',
    desc: '一部好的动画改编能让原作漫画焕发第二春。我们盘点2026年最成功的日漫改编动画，看看哪些作品实现了从"好看"到"封神"的跨越，以及背后的制作故事。',
    tag: '年度盘点',
    color: 'from-accent-500/90 to-accent-700/90',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20anime%20illustration%20with%20animation%20production%20aesthetic%2C%20warm%20golden%20and%20amber%20lighting%2C%20film%20strip%20motif%2C%20Japanese%20manga%20to%20anime%20transition%20feel%2C%20elegant%20composition%2C%20no%20text&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '推理日漫简史：从金田一到今日重现',
    desc: '日本推理漫画的脉络远比想象中丰富。从横沟正史到青山刚昌，从本格派到社会派，我们梳理推理日漫的发展历程，并推荐当下最值得入坑的推理新作。',
    tag: '类型探索',
    color: 'from-secondary-500/90 to-secondary-700/90',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20themed%20Japanese%20manga%20illustration%20with%20magnifying%20glass%20and%20clue%20motifs%2C%20warm%20sepia%20and%20amber%20tones%2C%20noir%20detective%20atmosphere%2C%20elegant%20editorial%20style%2C%20intellectual%20vibe%2C%20no%20text&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '漫画家特辑：那些改变了日漫的作者们',
    desc: '手冢治虫、鸟山明、富坚义博、尾田荣一郎……每一位伟大的漫画家都在日漫史上留下了不可磨灭的印记。本期特辑带你走进这些创作者的世界，了解他们的创作理念与传奇故事。',
    tag: '人物特写',
    color: 'from-primary-600/90 to-accent-600/90',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20Japanese%20manga%20creator%20studio%20illustration%20with%20warm%20lighting%2C%20ink%20and%20pen%20aesthetic%2C%20creative%20atmosphere%2C%20coral%20and%20amber%20color%20palette%2C%20inspirational%20mood%2C%20editorial%20photography%20style%2C%20no%20text&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            深度策划
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm mt-2">编辑团队深度策划的日漫主题内容</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <article
              key={item.id}
              className="group relative rounded-2xl overflow-hidden cursor-pointer min-h-[300px]"
            >
              <div className="absolute inset-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className={`absolute inset-0 bg-gradient-to-t ${item.color}`}></div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="relative z-10 p-6 md:p-8 flex flex-col justify-end h-full">
                <span className="inline-block px-2.5 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-medium mb-3 w-fit whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-white mb-3">
                  {item.title}
                </h3>
                <p className="text-sm text-white/75 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}